import * as React from "react";
const Component = props => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 5 9" {...props}><path xmlns="http://www.w3.org/2000/svg" stroke="#0B91D6" strokeLinejoin="round" d="m.5.5 4 4-4 4" /></svg>;
export default Component;